<script setup lang="ts">
// types
import type { BlockTestPickerRowProps } from '@ts-blocks/block-test-picker-row/interfaces'
// hooks
import { useBlockTestPickerRow } from '@hooks/blocks/block-test-picker-row.hook'
// components
import { Button, Icon } from '@brighterly/lib-lumee-ui'
import { BrandShapeIcon } from '@UI/Brand/BrandShapeIcon'

defineOptions({
  name: 'BlockTestPickerRow',
})

const props = defineProps<{
  block: BlockTestPickerRowProps
}>()

const {
  refDiscipline,
  refVisual,
  refHref,
  buttonLabel,
  handleClick,
} = useBlockTestPickerRow({
  block: () => props.block,
})
</script>

<template>
  <article
    class="block-test-picker-row"
    :class="`block-test-picker-row--${refDiscipline}`"
  >
    <div class="block-test-picker-row__lead">
      <BrandShapeIcon
        class="block-test-picker-row__plate"
        :shape="refVisual.shape"
        :color="refVisual.color"
        size="md"
      >
        <Icon
          :name="refVisual.glyph"
          size="lg"
          weight="solid"
          color="inverse"
        />
      </BrandShapeIcon>
      <div class="block-test-picker-row__content">
        <h3 class="block-test-picker-row__title btly-text-title-m">
          {{ block.title }}
        </h3>
        <p
          v-if="block.meta"
          class="block-test-picker-row__meta btly-text-body-m"
        >
          {{ block.meta }}
        </p>
      </div>
    </div>
    <a
      class="block-test-picker-row__cta"
      :href="refHref"
      @click="handleClick"
    >
      <Button
        view="secondary"
        size="sm"
        :text="buttonLabel"
        trailing-icon="arrow-right"
        tabindex="-1"
      />
    </a>
  </article>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockTestPickerRow.scss" />
